import React, { useState, useEffect } from "react";
import { Card, Tabs } from "antd";
import {
  FileTextOutlined,
  FilePdfOutlined,
  BankOutlined,
  SwapOutlined,
  CreditCardOutlined,
} from "@ant-design/icons";
import InvoiceHistory from "../Modals/InvoiceHistory";
import BillHistory from "../Modals/BillHistory";
import CreditHistory from "../Modals/CreditHistory";
import StatementHistory from "../Modals/StatementHistory";
import TransactionsHistory from "../../TransactionsAllocations/TransactionsHistory";
import AllocationHistory from "../../TransactionsAllocations/AllocationHistory";
import { useLocation } from "react-router-dom";

const { TabPane } = Tabs;

const ActionHistory = ({ selectedBrand = null }) => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("1");
  console.log(selectedBrand, "selectedBrand in action history");

  useEffect(() => {
    // Prefer location state, then localStorage
    if (location.state && location.state.activeTab) {
      setActiveTab(location.state.activeTab);
    } else if (localStorage.getItem("action_history_active_tab")) {
      setActiveTab(localStorage.getItem("action_history_active_tab"));
      localStorage.removeItem("action_history_active_tab");
    }
  }, [location]);

  const onTabChange = (key) => {
    setActiveTab(key);
  };

  return (
    <Card title="Action History" bordered={false} size="small">
      <Tabs activeKey={activeTab} onChange={onTabChange} size="small">
        <TabPane
          tab={
            <span>
              <FileTextOutlined className="me-2" />
              Invoice History
            </span>
          }
          key="1"
        >
          <InvoiceHistory selectedBrand={selectedBrand} />
        </TabPane>

        <TabPane
          tab={
            <span>
              <FilePdfOutlined className="me-2" />
              Bill History
            </span>
          }
          key="2"
        >
          <BillHistory selectedBrand={selectedBrand} />
        </TabPane>

        <TabPane
          tab={
            <span>
              <CreditCardOutlined className="me-2" />
              Credit History
            </span>
          }
          key="3"
        >
          <CreditHistory selectedBrand={selectedBrand} />
        </TabPane>

        <TabPane
          tab={
            <span>
              <BankOutlined className="me-2" />
              Statements History
            </span>
          }
          key="4"
        >
          <StatementHistory selectedBrand={selectedBrand} />
        </TabPane>

        <TabPane
          tab={
            <span>
              <BankOutlined className="me-2" />
              Transactions History
            </span>
          }
          key="5"
        >
          <TransactionsHistory selectedBrand={selectedBrand} />
        </TabPane>

        <TabPane
          tab={
            <span>
              <SwapOutlined className="me-2" />
              Allocation History
            </span>
          }
          key="6"
        >
          <AllocationHistory selectedBrand={selectedBrand} />
        </TabPane>
      </Tabs>
    </Card>
  );
};

export default ActionHistory;
